/*global window jQuery document hrglob*/
/*jslint evil: true */
var no_loader = 0;


//--------------------------------------------------------
// hrglob
(function(window, $) {
    // is only used inside, you should never publish this, instead use jquerys inarray
    function inArray(arr, val) {
        var i;
        for (i = 0; i < arr.length; ++i) {
            if (arr[i] === val) {
                return true;
            }
        }
        return false;
    }


    function jsonAddAndEval(str1, str2) {
        var obj1 = '';
        var obj2 = '';

        if (typeof str1 === 'object') {
            obj1 = str1;
        } else {
            obj1 = eval('(' + str1 + ')');
        }

        if (typeof str2 === 'object') {
            obj2 = str1;
        } else {
            obj2 = eval('(' + str2 + ')');
        }

        jQuery.extend(true, obj1, obj2);

        return obj1;
    }





    var hrglob = {
        version: '1.0',
        fillSelectKwByJahrMonat: function(yearId, monthId, kwId, createAllEntry) {
            var year = jQuery('#' + yearId);
            var month = jQuery('#' + monthId);
            var target = jQuery('#' + kwId);

            target.html('');

            var entrys = [];
            var i;
            for (i = 1; i <= 31; ++i) {
                var akw = hrglob.getKw(year.val(), month.val(), i);

                if (inArray(entrys, akw) === false) {
                    entrys.push(akw);
                }
            }

            var newHtml = '';
            if (typeof createAllEntry !== 'undefined') {
                newHtml = newHtml + '<option value"' + createAllEntry + '">- alle -</option>';
            }

            jQuery.each(entrys, function(key, val) {
                newHtml = newHtml + '<option value="' + val + '">' + val + '</option>';
            });

            target.html(newHtml);
        },
        checkGerDate: function(datum) {
            if (!datum) {
                return false;
            }
            datum = datum.toString();

            datum = datum.split(".");
            if (datum.length !== 3) {
                return false;
            }

            datum[0] = parseInt(datum[0], 10);
            datum[1] = parseInt(datum[1], 10) - 1;

            if (datum[2].length === 2) {
                datum[2] = "20" + datum[2];
            }

            datum[0] = parseInt(datum[0], 10);
            datum[1] = parseInt(datum[1], 10);
            datum[2] = parseInt(datum[2], 10);

            var kontrolldatum = new Date(datum[2], datum[1], datum[0]);

            if (kontrolldatum.getDate() === datum[0] && kontrolldatum.getMonth() === datum[1] && kontrolldatum.getFullYear() === datum[2]) {
                return true;
            }
            else {
                return false;
            }
        },
        attachRestOfDate: function() {
            var txt = jQuery(this).val();
            if (txt) {
                var mytime = new Date();
                var monat = mytime.getMonth() + 1;
                var jahr = mytime.getFullYear();
                var tag = mytime.getDate();

                txt = txt.replace(',', '.').replace('-', '.').replace('/', '.').replace(';', '.').replace(':', '.');
                var arr = txt.split('.');

                if (!arr[2]) {
                    arr[2] = jahr + '';
                }
                if (!arr[1]) {
                    arr[1] = monat + '';
                }
                if (!arr[0]) {
                    arr[0] = tag + '';
                }

                if (arr[0].length === 1) {
                    arr[0] = '0' + arr[0];
                }
                if (arr[1].length === 1) {
                    arr[1] = '0' + arr[1];
                }

                txt = arr[0] + '.' + arr[1] + '.' + arr[2];
                if (hrglob.checkGerDate(txt) === false) {
                    txt = '';
                }
                jQuery(this).val(txt);
            }
        },
        attachRestOfHour: function() {
            var txt = jQuery(this).val();
            if (txt) {
                var error = 0;
                txt = txt.replace(',', ':').replace('-', ':').replace('/', ':').replace(';', ':').replace('.', ':');
                var arr = txt.split(':');

                if ((arr[0].length === 4 || arr[0].length === 3) && arr[1] === undefined) {
                    arr[1] = arr[0].substr(2);
                    arr[0] = arr[0].substr(0, 2);
                }

                if (arr[1] !== undefined && arr[1].length === 1) {
                    arr[1] = arr[1] + '0';
                }



                if (!arr[1]) {
                    arr[1] = '00';
                }
                if (arr[3] !== undefined) {
                    error = 1;
                }

                arr[0] = parseInt(arr[0], 10);
                arr[1] = parseInt(arr[1], 10);

                if (isNaN(arr[0]) || isNaN(arr[1])) {
                    error = 1;
                }

                if (arr[0] === 0 && arr[1] === 0) {
                    arr[0] = 24;
                }

                if (arr[0] !== 24 || arr[1] !== 0) {
                    if (arr[0] < 0 || arr[0] > 23) {
                        error = 1;
                    }
                    if (arr[1] < 0 || arr[1] > 59) {
                        error = 1;
                    }
                }


                if (error === 0) {
                    arr[0] = String(arr[0]);
                    arr[1] = String(arr[1]);
                    if (arr[0].length === 1) {
                        arr[0] = '0' + arr[0];
                    }
                    if (arr[1].length === 1) {
                        arr[1] = '0' + arr[1];
                    }
                    txt = arr[0] + ':' + arr[1];
                } else {
                    txt = '';
                }


                jQuery(this).val(txt);
            }
        },
        checkNumber: function() {
            hrglob.checkNumberReadTitle(this);
            var txt = jQuery(this).val();
            if (txt) {
                txt = txt.replace(',', '.').replace('/', '.').replace(';', '.').replace(':', '.');

                var txt2 = parseFloat(txt);
                if (isNaN(txt2) || txt2 < jQuery.data(this, 'min') || txt2 > jQuery.data(this, 'max')) {
                    txt = '';
                }

                jQuery(this).val(txt);
            }
        },
        checkNumberReadTitle: function(obj) {
            if (!jQuery.data(obj, 'min') || !jQuery.data(obj, 'max')) {
                var min = -99999999;
                var max = 99999999;
                if (jQuery(obj).attr('title')) {
                    var min_match,
                            max_match,
                            title = jQuery(obj).attr('title');
                    min_match = title.match(/min=[\-\d.\d]*/);

                    if (min_match && min_match[0]) {
                        min_match[0].split('=')[1];
                    }

                    max_match = title.match(/max=[\-\d.\d]*/);

                    if (max_match && max_match[0]) {
                        max_match[0].split('=')[1];
                    }
                }
                jQuery.data(obj, 'min', min);
                jQuery.data(obj, 'max', max);
            }
        },
        // you should never use this function, please well format your json,
        // this function is depracated and will be removed, when its time
        processEval: function(str) {
            str = str.replace("}{", "}|split|{");
            str = str.split("|split|");

            var i;
            for (i = 0; i < str.length; ++i) {
                str[0] = jsonAddAndEval(str[0], str[i]);
            }

            return str[0];
        },
        addMonthTodate: function(datum, monate, trim_ende) {
            var d = datum.getDate();
            var m = datum.getMonth() + 1;
            var y = datum.getFullYear();


            m = m + monate;

            if (m > 12)
            {
                y = y + 1;
                m = m - 12;
            }

            datum.setDate(d);
            datum.setMonth(m - 1);
            datum.setFullYear(y);


            if (trim_ende === true)
            {
                if ((datum.getMonth() + 1) > m)
                {
                    d = hrglob.getLastDayOfMonth(y, m - 1);
                    datum.setDate(d);
                    datum.setMonth(m - 1);
                }
            }
        },
        getJsdateFromGerdate: function(datum) {
            if (!datum) {
                return false;
            }
            datum = datum.toString();

            datum = datum.split(".");
            if (datum.length !== 3) {
                return false;
            }

            datum[0] = parseInt(datum[0], 10);
            datum[1] = parseInt(datum[1], 10) - 1;

            if (datum[2].length === 2) {
                datum[2] = "20" + datum[2];
            }
            var kontrolldatum = new Date(datum[2], datum[1], datum[0]);

            return kontrolldatum;
        },
        getGerdateFromJsdate: function(datum) {
            var d = String(datum.getDate());
            if (d.length === 1) {
                d = '0' + d;
            }

            var m = parseInt(datum.getMonth(), 10);
            m = m + 1;
            m = String(m);
            if (m.length === 1) {
                m = '0' + m;
            }
            var y = datum.getFullYear();

            return d + '.' + m + '.' + y;
        },
        getLastDayOfMonth: function(Year, Month) {
            return(new Date((new Date(Year, Month + 1, 1)) - 1)).getDate();
        },
        resetFormById: function(id) {
            jQuery('#' + id).each(function() {
                this.reset();
            });
        },
        emulateOldTabs: function(tabid, pk) {
            var seltab = jQuery('#' + tabid).tabs('option', 'active');
            var formIdToSubmit = '';
            jQuery('#' + tabid + ' > div').each(function(index, obj) {
                var form = jQuery('#' + obj.id + ' form').attr('id');
                if (seltab === index) {
                    formIdToSubmit = form;
                } else {
                    hrglob.resetFormById(form);
                }
            });

            //var tabcnt = jQuery('#'+tabid).tabs( 'length' );
            var tabcnt = $('#' + tabid + ' >ul >li').size();
            var mode = 'enable';

            if (!pk && pk !== 0) {
                mode = 'disable';
            }

            var i;
            for (i = 1; i <= tabcnt; i++) {
                jQuery('#' + tabid).tabs(mode, i - 1);
            }

            return formIdToSubmit;
        },
        getKw: function(j, m, t) {
            var Datum = new Date();
            if (!t) {
                j = Datum.getYear();
                if (1900 > j) {
                    j += 1900;
                }
                m = Datum.getMonth();
                t = Datum.getDate();
            }
            else {
                m = m - 1;
            }

            Datum = new Date(j, m, t, 0, 0, 1);
            var tag = Datum.getDay();
            if (tag === 0) {
                tag = 7;
            }
            var d = new Date(2004, 0, 1).getTimezoneOffset();
            var Sommerzeit = (Date.UTC(j, m, t, 0, d, 1) - Number(Datum)) / 3600000;
            Datum.setTime(Number(Datum) + Sommerzeit * 3600000 - (tag - 1) * 86400000);
            var Jahr = Datum.getYear();

            if (1900 > Jahr) {
                Jahr += 1900;
            }

            var kw = 1;
            if (new Date(Jahr, 11, 29) > Datum) {
                var Start = new Date(Jahr, 0, 1);
                Start = new Date(Number(Start) + 86400000 * (8 - Start.getDay()));

                if (Start.getDate() > 4) {
                    Start.setTime(Number(Start) - 604800000);
                }
                kw = Math.ceil((Datum.getTime() - Start) / 604800000);
            }
            return kw;
        },
        datepicker_options: {
            showOn: 'button',
            buttonImage: 'images/icon_calendar_pop.gif',
            buttonImageOnly: true,
            showAnim: 'slideDown',
            dateFormat: 'dd.mm.yy'
        },
        loadDatepickers: function() {
            jQuery("input.datum").datepicker(hrglob.datepicker_options);
        }



    };

    // Expose hrglob to the global object
    return (window.hrglob = hrglob);
}(window, jQuery));
// hrglob
//--------------------------------------------------------



//--------------------------------------------------------
// jQuery extensions: serializeAll und serializeArrayAll
(function($) {
    $.fn.extend({
        serializeAll: function() {
            return jQuery.param(this.serializeArrayAll());
        },
        serializeArrayAll: function() {
            return this.map(function() {
                return this.elements ? jQuery.makeArray(this.elements) : this;
            })
                    .filter(function() {
                        return this.name && (this.checked || /select|textarea/i.test(this.nodeName) || /color|date|datetime|email|hidden|month|number|password|range|search|tel|text|time|url|week/i.test(this.type));
                    })
                    .map(function(i, elem) {
                        var val = jQuery(this).val();

                        return val === null ?
                                null :
                                jQuery.isArray(val) ?
                                jQuery.map(val, function(val, i) {
                                    return {name: elem.name, value: val};
                                }) :
                                {name: elem.name, value: val};
                    }).get();
        }
    });
}(jQuery));
//jQuery extensions: serializeAll und serializeArrayAll
//--------------------------------------------------------




// -------------------------------------------------------
//blur+focus bei jQuery.live()
(function($) {

    var uid1 = 'D' + (+new Date()),
            uid2 = 'D' + (+new Date() + 1);

    jQuery.event.special.focus = {
        setup: function() {
            var _self = this,
                    handler = function(e) {
                        e = jQuery.event.fix(e);
                        e.type = 'focus';
                        if (_self === document && typeof(jQuery.event.handle) !== 'undefined') {
                            jQuery.event.handle.call(_self, e);
                        }
                    };

            jQuery(this).data(uid1, handler);

            if (_self === document) {
                /* Must be live() */
                if (_self.addEventListener) {
                    _self.addEventListener('focus', handler, true);
                } else {
                    _self.attachEvent('onfocusin', handler);
                }
            } else {
                return false;
            }

        },
        teardown: function() {
            var handler = jQuery(this).data(uid1);
            if (this === document) {
                if (this.removeEventListener) {
                    this.removeEventListener('focus', handler, true);
                } else {
                    this.detachEvent('onfocusin', handler);
                }
            }
        }
    };

    jQuery.event.special.blur = {
        setup: function() {
            var _self = this,
                    handler = function(e) {
                        e = jQuery.event.fix(e);
                        e.type = 'blur';
                        if (_self === document && typeof(jQuery.event.handle) !== 'undefined') {
                            jQuery.event.handle.call(_self, e);
                        }
                    };

            jQuery(this).data(uid2, handler);

            if (_self === document) {
                /* Must be live() */
                if (_self.addEventListener) {
                    _self.addEventListener('blur', handler, true);
                } else {
                    _self.attachEvent('onfocusout', handler);
                }
            } else {
                return false;
            }

        },
        teardown: function() {
            var handler = jQuery(this).data(uid2);
            if (this === document) {
                if (this.removeEventListener) {
                    this.removeEventListener('blur', handler, true);
                } else {
                    this.detachEvent('onfocusout', handler);
                }
            }
        }
    };
}(jQuery));
//blur+focus bei jQuery.live()
//-------------------------------------------------------


//-------------------------------------------------------
// bind event handlers
jQuery(function() {
    // loader
    jQuery(document).ajaxStart(function() {
        if (no_loader === 0) {
            jQuery('.loading').show();
        }
    });

    jQuery(document).ajaxStop(function() {
        jQuery('.loading').hide();
    });

    jQuery(".nummer").on('keydown', function(e) {
        if (e.keyCode === 32) { // leertaste
            e.preventDefault();
        }
        hrglob.checkNumberReadTitle(this);

        if (e.keyCode === 188 || e.keyCode === 190 || e.keyCode === 110) {
            var myval = jQuery(this).val();

            if (myval.search(/\./) === -1) {
                jQuery(this).val(myval + '.');
            }
            e.preventDefault();
        }
    });

    jQuery("input.nummer").on('blur', hrglob.checkNumber);
    jQuery("input.stunde").on('blur', hrglob.attachRestOfHour);
    jQuery("input.datum").on('blur', hrglob.attachRestOfDate);
    hrglob.loadDatepickers();
});
//bind event handlers
//-------------------------------------------------------

